import {CityProps, translatedCityProps} from 'modules/cities/types';
import {CompanyProps, translatedCompanyProps} from 'modules/companies/types';
import {OrderProps} from 'modules/orders/types';
import {
  PermissionGroupProps,
  translatedPermissionGroupProps,
} from 'modules/permission-groups/types';
import {translatedUserProps, UserProps} from 'modules/users/types';
import {TranslatedKeys} from 'shared/types/translated-keys';

export enum DeliveryManStatusEnum {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
  DISABLED = 'DISABLED',
}

export const translatedDeliveryManStatus: Record<
  DeliveryManStatusEnum,
  string
> = {
  [DeliveryManStatusEnum.ONLINE]: 'Online',
  [DeliveryManStatusEnum.OFFLINE]: 'Offline',
  [DeliveryManStatusEnum.DISABLED]: 'Desativado',
};

export interface AccessControlProps {
  id: string;
  userId: string;
  user: UserProps & {ordersAsDeliveryMan: OrderProps[]};
  cityId?: string;
  city?: CityProps;
  companyId?: string;
  company?: CompanyProps;
  permissionGroupId: string;
  permissionGroup: PermissionGroupProps;
  isFranchiseAccessControl: boolean;
  isDeliveryManAccessControl: boolean;
  maxDeliveryQuantity?: number;
  deliveryManStatus: DeliveryManStatusEnum;
  latitude?: number;
  longitude?: number;
  status?: AccessControlStatusEnum;
  averageDeliveryDuration?: number;
  numberOfDeliveries?: number;
  userName?: string;
  cityName?: string;
}

export enum AccessControlStatusEnum {
  awaiting_approval = 'awaiting_approval',
  reproved = 'reproved',
  approved = 'approved',
}

export const translatedAccessControlProps: TranslatedKeys<AccessControlProps> =
  {
    userId: 'Usuário',
    user: {
      ...translatedUserProps,
      name: 'Nome',
    } as any,
    cityId: 'Cidade',
    city: {...translatedCityProps, name: 'Cidade'},
    permissionGroupId: 'Grupo de permissões',
    permissionGroup: {
      ...translatedPermissionGroupProps,
      name: 'Grupo de permissões',
    },
    companyId: 'Empresa',
    company: {...translatedCompanyProps, name: 'Empresa'},
    isFranchiseAccessControl: 'Acesso a franquia?',
    isDeliveryManAccessControl: 'Entregador?',
    maxDeliveryQuantity: 'Quantidade máxima de pedidos',
    deliveryManStatus: 'Status do entregador',
    status: 'Status do acesso',
    averageDeliveryDuration: 'Tempo médio de entrega',
    numberOfDeliveries: 'Quantidade de entregas',
    cityName: 'Cidade',
    userName: 'Nome',
  };
